import { ReactNode } from 'react';

interface ActionsProps {
  children: ReactNode;
  className?: string;
}

const Actions = ({ children, className = '' }: ActionsProps) => {
  return (
    <div className={className} data-testid="cta-subnav-actions">
      {children}
    </div>
  );
};

export default Actions;
